import React from 'react';
import './warning-layer-popup.styles.scss';

const WarningLayerPopup = ({warningType, text, hideWarning}) => (
    <div className="warningLayer warningLayerPopup warning-hide">
        <div className="warningInfo">
            <img className="warningImg" src={require(`../../assets/images/${warningType === 'success' ? 'success.png' : 'warning.png'}`)} alt="" />
            <div className="warningText">{text}</div>
        </div>
        <button type="button" onClick={hideWarning}> <img className="closeImg" src={require(`../../assets/images/warning-close.png`)} title="close" alt="close" /></button>
    </div>
);

export default WarningLayerPopup;